"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var EmailField = function EmailField(props) {
  var id = props.id,
    className = props.className,
    label = props.label,
    emailAddressPath = props.emailAddressPath,
    primaryPath = props.primaryPath,
    emailInputClassName = props.emailInputClassName,
    emailPrimaryClassName = props.emailPrimaryClassName,
    primary = props.primary;
  var emailContainerClass = function emailContainerClass() {
    return (0, _classnames["default"])({
      'ui-email-field': true
    }, className);
  };
  var emailInputClass = function emailInputClass() {
    return (0, _classnames["default"])({
      'ui-email-field__input': true
    }, emailInputClassName);
  };
  var emailPrimaryClass = function emailPrimaryClass() {
    return (0, _classnames["default"])({
      'ui-email-field__checkbox': true
    }, emailPrimaryClassName);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: emailContainerClass()
  }, /*#__PURE__*/_react["default"].createElement(_ui.InputField, _extends({
    id: id,
    className: emailInputClass(),
    name: "email",
    label: label
  }, _lodash["default"].get(props, emailAddressPath, {}))), primary ? /*#__PURE__*/_react["default"].createElement(_ui.CheckBoxField, _extends({
    id: "checkbox-field-primary",
    className: emailPrimaryClass(),
    label: "Primary"
  }, _lodash["default"].get(props, primaryPath, {}))) : null);
};
EmailField.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** className for reference */
  className: _propTypes["default"].string,
  /** label text for button */
  label: _propTypes["default"].string,
  /** email input field path name */
  emailAddressPath: _propTypes["default"].string,
  /** email checkbox field path primary */
  primaryPath: _propTypes["default"].string,
  /** email input className */
  emailInputClassName: _propTypes["default"].string,
  /** email primary checkbox className */
  emailPrimaryClassName: _propTypes["default"].string,
  /** If true, display the primary checkbox */
  primary: _propTypes["default"].bool
};
EmailField.defaultProps = {
  className: '',
  emailAddressPath: 'email',
  primaryPath: 'primary',
  label: '',
  emailInputClassName: '',
  emailPrimaryClassName: '',
  primary: true
};
var _default = exports["default"] = EmailField;